module.exports = __webpack_public_path__ + "img/t5.6b028660.jpg";